var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center",attrs:{"id":"wrapper-card"}},[_c('p',{staticClass:"gray-font-title"},[_vm._v(_vm._s(_vm.title))]),_c('p',{staticClass:"number"},[_vm._v("Total: "+_vm._s(_vm.data1)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }